import React from 'react'

const CircleXIcon = (
  <>
    <path
      d="M26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13Z"
      fill="#FAFAFA"
    />
    <path
      opacity="0.6"
      d="M15.0366 13.0441L18.0988 9.98183C18.4652 9.61802 18.6097 9.08637 18.4778 8.58715C18.3459 8.08794 17.9578 7.697 17.4595 7.5616C16.9612 7.4262 16.4286 7.5669 16.0622 7.93072L12.9999 11.0074L9.93771 7.94516C9.37131 7.38275 8.45623 7.38599 7.89382 7.95239C7.33141 8.51879 7.33465 9.43387 7.90104 9.99628L10.9633 13.0441L7.90104 16.1063C7.41026 16.6794 7.44325 17.5337 7.97679 18.0672C8.51032 18.6007 9.36461 18.6337 9.93771 18.1429L12.9999 15.0807L16.0622 18.1429C16.6353 18.6337 17.4895 18.6007 18.0231 18.0672C18.5566 17.5337 18.5896 16.6794 18.0988 16.1063L15.0366 13.0441Z"
      fill="#E01E4E"
    />
  </>
)

export default CircleXIcon
